import { NotificationsActiveRounded } from '@mui/icons-material';
import { getNumberOfUnseenNotifications } from '@common-reducers/NotificationsSelectors';
import { taskActions } from '@common-reducers/TasksReducer';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import classes from "./tasks-header.module.scss";

type Props = {}

export default function NotificationsButton({ }: Props) {
    const dispatch = useAppDispatch();

    const numberOfUnseenNotifications = useAppSelector((state) => getNumberOfUnseenNotifications(state))


    const openNotificationsDrawer = () => {
        dispatch(taskActions.setTaskViewSideDrawerOpenWith("notificationsDrawer"))
    }


    return (
        <div style={{ position: 'relative' }}>
            {numberOfUnseenNotifications > 0 && (
                <div className={classes.redCircle}>
                    {numberOfUnseenNotifications}
                </div>
            )}
            <button className={classes.button + " " + classes.with_shadow_on_hover} onClick={openNotificationsDrawer}>
                <NotificationsActiveRounded />
            </button>
        </div>
    )
}